export const handleWhatsAppClick = () => {
    window.gtag('event', 'conversion', {
        'send_to': 'AW-10999490476/b6lrCO7Hh8oZEKzP-_wo',
        'event_callback': () => {
            window.open('https://wa.me/917796614664', '_blank');
        }
    });

    return false;
};
